import { useState } from "react";
import { useLocation } from "react-router-dom";
import { FormikHelpers } from "formik";
import { useSnackbar } from "notistack";

import { IAuthService } from "../../../../modules/user/models/IAuthService";
import { useIocContext } from "../../../../contexts/ioc/IocContext";
import { Types } from "../../../../ioc/types";
import { getSnackbar } from "../../../../utils/Snackbars";
import AppError from "../../../../utils/appError";
import { encodeToken, updateTokenInUrl } from "../../../Login/LoginDefault/form/initialValues";
import { FormikValuesUpdatePassword } from "../form/interfaceValues";

// Lógica única da troca de senha no primeiro acesso, extraída de UpdatePasswordDefault.
// Mesma regra (nova != antiga), updatePassword(email/old/new), encodeToken + updateTokenInUrl
// no sucesso, mapeamento de "not found" e snackbars. Consumida pela Default e pela Branded.
export function useUpdatePasswordSubmit() {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const oldPassword = location?.state?.password || "";
  const email = location?.state?.email || "";

  const iocContext = useIocContext();
  const authService = iocContext.serviceContainer.get<IAuthService>(Types.User.IAuthService);

  const [successUpdatePassword, setSuccessUpdatePassword] = useState(false);

  const handleSubmit = async (
    values: FormikValuesUpdatePassword,
    actions: FormikHelpers<FormikValuesUpdatePassword>
  ) => {
    try {
      if (oldPassword === values.newPass) {
        throw new Error("A senha atual não pode ser igual a senha anterior!");
      }

      const payload = {
        email: values.email,
        old_password: oldPassword,
        new_password: values.newPass,
      };

      await authService.updatePassword(payload);
      const newToken = encodeToken(values.email, values.newPass);
      updateTokenInUrl(newToken);
      actions.resetForm();
      setSuccessUpdatePassword(true);

      enqueueSnackbar(
        getSnackbar({ message: "Senha atualizada com sucesso", variant: "success" })
      );
    } catch (error) {
      setSuccessUpdatePassword(false);

      // A camada HTTP lança AppError (não estende Error); por isso o guard cobre os dois,
      // senão a mensagem do backend viraria "[object Object]".
      const rawMessage =
        error instanceof AppError || error instanceof Error
          ? error.message
          : "Erro inesperado, tente novamente.";
      const message =
        rawMessage.indexOf("not found") !== -1
          ? "Error: Usuario nao encontrado"
          : rawMessage;

      enqueueSnackbar(getSnackbar({ message, variant: "error" }));
    }
  };

  return { handleSubmit, successUpdatePassword, email };
}
